import { MediumTextStyles } from '@components/typography/interVariants';
import { styled } from '@styledComponents';
import { themeColor, themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';
import { ReactComponent as ClearIcon } from './clear.svg';
import { ReactComponent as SearchIcon } from './search.svg';
import { SearchVariant } from './SearchBar';
import { ButtonNoneStyled } from '@components/ButtonNoneStyled';

export const SearchWrapper = styled.form`
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
`;

export const StyledInput = styled.input<{ variant: SearchVariant }>`
  width: 100%;
  height: ${(props) => (props.variant === 'secondary' ? themeSpace(9) : '59px')};
  border: none;
  font-size: 16px;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: ${themeSpace(8)};
  padding-right: 40px;
  padding-left: ${(props) =>
    props.variant === 'secondary'
      ? themeSpace(6)
      : `calc(${themeSpace(9)({ theme: props.theme })} + ${themeSpace(3)({ theme: props.theme })})`};
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.03), 0px 10px 60px - 20px rgba(44, 41, 37, 0.03), 0px 9px 36px - 30px rgba(0, 0, 0, 0.04);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${MediumTextStyles}

  ${themeMediaQuery('below_sm')} {
    height: 48px;
    font-size: 14px;
    padding-left: ${(props) => (props.variant === 'secondary' ? themeSpace(6) : themeSpace(8))};
  }

  :hover {
    border-color: rgb(166, 166, 166);
  }

  :focus {
    outline: none;
    border-color: rgb(118, 118, 118);
  }

  :focus::placeholder {
    color: transparent;
  }
`;

export const StyledButton = styled(ButtonNoneStyled)<{ variant: SearchVariant }>`
  position: absolute;
  top: ${themeSpace(3)};
  right: ${themeSpace(3)};
  ${themeVariant('featureHed17')};
  color: white;
  border-radius: ${themeSpace(8)};
  background-color: ${themeColor('mono1')};
  padding: ${themeSpace(3)} ${themeSpace(6)};
  ${(props) =>
    props.variant === 'secondary' && {
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 'auto',
      height: 'auto',
    }}
  &:hover {
    background-color: #4d4d4d;
  }

  &:active {
    background-color: #000;
  }

  ${themeMediaQuery('below_sm')} {
    font-size: 14px;
    width: 92px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: ${themeSpace(2)};
    right: ${themeSpace(2)};
    ${(props) =>
      props.variant === 'secondary' && {
        width: 'auto',
        height: 'auto',
      }}
  }
`;

export const StyledSearchIcon = styled(SearchIcon)`
  position: absolute;
  top: 13px;
  left: ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    width: 24px;
    height: 24px;
    top: ${themeSpace(4)};
    left: ${themeSpace(3)};
  }
`;

export const ClearButton = styled(ClearIcon)<{ variant: SearchVariant }>`
  position: absolute;
  cursor: pointer;
  color: ${themeColor('mono4')};
  top: ${(props) => (props.variant === 'secondary' ? '12px' : '18px')};
  right: ${(props) => (props.variant === 'secondary' ? themeSpace(10) : themeSpace(12))};
  ${themeMediaQuery('below_sm')} {
    width: 24px;
    height: 24px;
    top: 13px;
    right: ${(props) => (props.variant === 'secondary' ? themeSpace(9) : '104px')};
  }

  &:hover {
    color: ${themeColor('mono3')};
  }

  &:active {
    color: ${themeColor('mono2Fitty')};
  }
`;
